import { createSlice } from '@reduxjs/toolkit';
import { IAuthUser } from '../../../models/Auth';
import { AppThunk } from '../../store';
import { selectAppLoadComplete, selectAuthUser, selectDataLoadComplete } from './AuthSelector';

interface AuthState {
    authuser: IAuthUser | null,
    appLoadComplete: boolean,
    dataLoadComplete: boolean //System Lookups.  
}

const initialState: AuthState = {
    authuser: null,
    appLoadComplete: false,
    dataLoadComplete: false 
}

const slice = createSlice({
    name: 'auth',
    initialState, 
    reducers: {
        authStateAction: (state, action) => {
            state.authuser = action.payload;
            state.appLoadComplete = true;
        },
        appLoadCompleteAction: (state, action) => {
            state.appLoadComplete = action.payload;
        },
        dataLoadCompleteAction: (state, action) => {
            state.dataLoadComplete = action.payload;
        }
    }
});

export const { 
    authStateAction, 
    appLoadCompleteAction, 
    dataLoadCompleteAction 
} = slice.actions;

//Thunks
export const setAuthState = (value: IAuthUser | null): AppThunk => (dispatch, getState) => 
{
    const currentvalue = selectAuthUser(getState());

    const currentUser = currentvalue !== null ? JSON.stringify(currentvalue.user) : "";
    const newUser = value !== null ? JSON.stringify(value.user) : "";

    if(currentUser !== newUser) {
        //cause page soft refresh to avoid hook mismatch if currentUser is not equal to newUser.
        dispatch(appLoadCompleteAction(false));
        dispatch(dataLoadCompleteAction(false));
    }

    if(currentvalue !== value)
    {
        dispatch(authStateAction(value))
    }
};

export const SetAppLoadComplete = (value: boolean): AppThunk => (dispatch, getState) => {

    const currentvalue = (selectAppLoadComplete(getState()));
    if(currentvalue !== value) {
        dispatch(appLoadCompleteAction(value));
    }
}

export const SetDataLoadComplete = (value: boolean): AppThunk => (dispatch, getState) => {
    const currentvalue = (selectDataLoadComplete(getState()));
    if(currentvalue !== value) {
        dispatch(dataLoadCompleteAction(value));
    }
}




export default slice.reducer;